<template>
  <el-form
    class="tab_form"
    status-icon
    :model="user"
    :rules="rules"
    ref="user"
    @keyup.enter.native="reset"
    :label-position="formConfig.labelPosition"
    :label-width="formConfig.labelWidth"
  >
    <div class="input_group">
      <div class="reset_input">
        <el-form-item class prop="loginid">
          <div class="reset_label" slot="label">
            <div class="label_text">{{formLabel.accountName}}</div>
          </div>
          <el-input
            id="loginid"
            class="input"
            v-model="user.loginid"
            maxlength="11"
            autocomplete="new-password"
            prefix-icon="el-icon-user"
            :disabled="true"
          ></el-input>
        </el-form-item>
      </div>
      <div class="reset_input">
        <el-form-item class prop="password">
          <div class="reset_label" slot="label">
            <div class="label_text">{{formLabel.password}}</div>
          </div>
          <el-input
            id="password"
            class="input"
            type="password"
            v-model="user.password"
            autocomplete="new-password"
            prefix-icon="el-icon-lock"
            show-password
          ></el-input>
          <span class="gray error_msg">{{$t("changePassword_pageText.TIP")}}</span>
        </el-form-item>
      </div>
      <div class="reset_input" v-show="user.password">
        <el-form-item class prop="repasswd">
          <div class="reset_label" slot="label">
            <div class="label_text">{{formLabel.repasswd}}</div>
          </div>
          <el-input
            id="repasswd"
            class="input"
            type="password"
            v-model="user.repasswd"
            autocomplete="new-password"
            prefix-icon="el-icon-lock"
            show-password
          ></el-input>
          <span class="red error_msg" slot="error" slot-scope="slotScope">
            <i class="icon el-icon-warning" style></i>
            {{ slotScope.error }}
          </span>
        </el-form-item>
      </div>
      <!-- <div class="reset_input"> 
        <el-form-item class prop="captcha">
          <div class="reset_label" slot="label">
            <div class="label_text">{{formLabel.captcha}}</div>
          </div>
          <el-input
            id="captcha"
            class="input"
            v-model="user.captcha"
            autocomplete="new-password"
            :placeholder="formLabel.captcha"
            v-if="!url"
          ></el-input>
          <div class="flex flex-align-items-center" v-if="url">
            <el-input
              id="captcha"
              class="input flex1"
              v-model="user.captcha"
              autocomplete="new-password"
              :placeholder="formLabel.captcha"
            ></el-input>
            <el-image :src="url" slot="append" @click="getCaptcha" class="captcha"></el-image>
          </div>
          <span class="red error_msg" slot="error" slot-scope="slotScope">
            <i class="icon el-icon-warning" style></i>
            {{ slotScope.error }}
          </span>
        </el-form-item>
      </div>-->
    </div>
    <div class="reset_btn">
      <el-button
        type="primary"
        class="btn-reset size-16"
        @click="reset"
        :loading="loading"
        :disabled="loading"
      >{{ loading ? buttonLabel.loading : buttonLabel.reset }}</el-button>
    </div>
  </el-form>
</template>
<script>
import { isNotNullORBlank, getQueryStr } from "../../utils/utils";
export default {
  data() {
    let validateRepassword = (rule, value, callback) => {
      let _this = this;
      let msg = "";
      if (_this.user.password) {
        if (value) {
          if (value != _this.user.password) {
            msg = _this.$t("changePassword_pageText.DIFFERENT");
            setTimeout(() => {
              callback(new Error(msg));
            }, 300);
            return;
          }
        } else {
          msg = _this.$t("changePassword_pageText.PLEASEINPUTREPASS");
          setTimeout(() => {
            callback(new Error(msg));
          }, 300);
          return;
        }
      }
      setTimeout(() => {
        callback();
      }, 300);
    };
    // let validateCaptcha = (rule, value, callback) => {
    //   let _this = this;
    //   let msg = "";
    //   if (!value) {
    //     msg = _this.$t("changePassword_pageText.PLEASEINPUTCAPTCH");
    //     setTimeout(() => {
    //       callback(new Error(msg));
    //     }, 300);
    //   } else {
    //     setTimeout(() => {
    //       callback();
    //     }, 300);
    //   }
    // };
    return {
      formConfig: {
        labelPosition: "right",
        labelWidth: "100px"
      },
      showError: false,
      errMsg: "",
      rules: {
        repasswd: [{ validator: validateRepassword, trigger: "blur" }],
        //captcha: [{ validator: validateCaptcha, trigger: "blur" }]
      },
      formLabel: {
        accountName: this.$t("changePassword_pageText.ACCOUNTNAME"),
        password: this.$t("changePassword_pageText.PASSWORD"),
        repasswd: this.$t("changePassword_pageText.RESET_PASSWD"),
        captcha: this.$t("changePassword_pageText.CAPTCHA")
      },
      buttonLabel: {
        loading: this.$t("changePassword_pageText.LOADING"),
        reset: this.$t("changePassword_pageText.RE_SET")
      }
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => {
        return {
          loginid: "",
          password: "",
          repasswd: "",
          captcha: "",
          langcode: ""
        };
      }
    },
    url: {
      type: String,
      default: ""
    }
  },
  methods: {
    reset() {
      let _this = this;
      _this.$refs.user.validate(valid => {
        if (valid) {
          _this.$emit("reset");
        }
      });
    },
    getCaptcha() {
      this.$emit("get-captcha");
    }
  },
  watch: {
    "$i18n.locale"(curVal, oldVal) {
      this.formLabel.accountName = this.$t(
        "changePassword_pageText.ACCOUNTNAME"
      );
      this.formLabel.password = this.$t("changePassword_pageText.PASSWORD");
      this.formLabel.repasswd = this.$t("changePassword_pageText.RESET_PASSWD");
      this.formLabel.captcha = this.$t("changePassword_pageText.CAPTCHA");
      this.buttonLabel.loading = this.$t("changePassword_pageText.LOADING");
      this.buttonLabel.reset = this.$t("changePassword_pageText.RE_SET");
    },
    "user.password"(curVal, oldVal) {
      if (!curVal && this.user.repasswd) {
        this.user.repasswd = "";
        return;
      }
      this.$refs.user.validateField("repasswd");
    }
  }
};
</script>
<style>
.tab_form .el-input__inner {
  height: 50px;
  line-height: 48px;
  /* padding-left: 10px; */
  /* border: 1px solid #bfbfbf; */
}
</style>
<style scoped>
.tab_form {
  /* display: flex; */
  overflow: hidden;
}
.input_group {
  padding: 0 60px;
}
.reset_input {
  height: 100px;
  margin: 0 auto;
}
.reset_label {
  height: 50px;
  line-height: 50px;
  text-align: right;
  position: relative;
}
.label_text {
  display: inline-block;
  vertical-align: middle;
  line-height: 1.5;
}
.input {
  /* width: 459px; */
  color: #999;
}
.error_box {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 38px;
  margin: 5px 0;
  color: #e55646;
  text-align: center;
}
.error_msg {
  display: block;
}
.reset_btn {
  padding-top: 30px;
  text-align: center;
}
.btn-reset {
  width: 314px;
  height: 50px;
  /* line-height: 36px; */
  margin: 0 auto 15px auto;
  font-weight: 700;
}

.reset_forgot {
  text-align: right;
}

.forgot_link {
  display: inline-block;
  margin-bottom: 10px;
  color: #ffa000;
}

.forgot_link::focus,
.forgot_linke::active {
  color: #ffa000;
}

.reset_regist {
  text-align: right;
}

.noaccount {
  display: inline-block;
  color: #666;
}

.regist_link {
  display: inline-block;
  margin-left: 10px;
}

.freeregist {
  color: #666;
}

.captcha {
  margin-left: 10px;
  height: 38px;
  cursor: pointer;
}
</style>


